import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import {
  JackingFormInstanceEditor,
  JackingFinalValuesTemplateEditor
} from '../../../../../../../models/jacking-v2/jacking.models';

@Component({
  selector: 'jacking-final-position-grid',
  templateUrl: 'jacking-final-position-grid.component.html'
})
export class JackingFinalPositionGridComponent implements OnInit, OnChanges {
  @Input() editor: JackingFormInstanceEditor;
  @Input() legsCount: number;
  @Input() orderedLegNumbers: number[] = [];
  @Input() isReadonly: boolean = false;

  // used to control how the positioning grid tabbing works - need a safe offset so tabbing doesn't clash with other controls
  tabBase = 10000;

  get tabNorthingStart(): number { return this.tabBase; }
  get tabCrpNorthing(): number { return this.tabNorthingStart + this.positionGridLegNumbers.length; }
  get tabEastingStart(): number { return this.tabCrpNorthing + 1; } // after CRP N
  get tabCrpEasting(): number { return this.tabEastingStart + this.positionGridLegNumbers.length; }
  get tabWideStart(): number { return this.tabCrpEasting + 1; }

  ngOnInit() {
    this.safeInit();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['editor']) {
      this.safeInit();
    }
  }

  private safeInit() {
    if (!this.editor) { return; }

    (this.editor as any).jackingFinalValues = (this.editor as any).jackingFinalValues || {};

    this.ensurePositionShell();
    this.ensurePositionLegRows();
  }

  get finalValuesTemplate(): JackingFinalValuesTemplateEditor {
    return (this.editor as any)?.template?.finalValuesTemplate || null;
  }

  get position(): any {
    return (this.editor as any)?.jackingFinalValues?.position || null;
  }

  get positionGridLegNumbers(): number[] {
    return [...(this.orderedLegNumbers || [])].sort((a, b) => a - b);
  }

  private ensurePositionShell() {
    if (!this.finalValuesTemplate?.hasNorthingEasting) { return; }

    const root = (this.editor as any).jackingFinalValues;

    root.position = root.position || {
      id: 0,
      legs: [],
      northingCrpPosition: null,
      eastingCrpPosition: null,
      headingT: null,
      requiredDistanceToAsset: null,
      actualDistanceToAsset: null
    };

    root.position.legs = root.position.legs || [];
  }

  getPositionLeg = (legNumber: number): any => {
    const root = this.position;
    if (!root) { return { id: 0, legNumber, northing: null, easting: null }; }

    const existing = (root.legs || []).find(l => l.legNumber === legNumber);
    if (existing) { return existing; }

    const placeholder = { id: 0, legNumber, northing: null, easting: null };
    root.legs.push(placeholder);
    return placeholder;
  }

  private ensurePositionLegRows() {
    if (!this.finalValuesTemplate?.hasNorthingEasting || !this.position) { return; }
    this.positionGridLegNumbers.forEach(n => this.getPositionLeg(n));
  }
}



// WEBPACK FOOTER //
// ./src/pages/jacking-activities/v2/components/jacking-events/jacking-final-values/jacking-final-position-grid/jacking-final-position-grid.component.ts